export default __webpack_public_path__ + "static/node-5be0db91cf788039f2a9978cf9ffc4ea.png";